import axios from 'axios';
import { BEACONCHAIN_URL } from './envVars';

interface EpochData {
  data: {
    validatorscount: number;
    eligibleether: number;
  };
}
export interface FetchTotalValidatorsResponse {
  statusCode: number;
  body: {
    totalValidators: number;
    eligibleether: number;
    msg?: unknown;
  };
}

export const fetchTotalValidators = async (): Promise<FetchTotalValidatorsResponse> => {
  const { href } = new URL('/api/v1/epoch/latest', BEACONCHAIN_URL);
  try {
    const response = await axios.get<EpochData>(href);
    if (response.status !== 200) throw new Error(response.statusText);
    const { data } = response;
    const { validatorscount: totalValidators, eligibleether } = data.data;
    return { statusCode: 200, body: { totalValidators, eligibleether } };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return {
      statusCode: 500,
      body: {
        totalValidators: 0,
        eligibleether: 0,
        msg: error,
      },
    };
  }
};
